<template>
  <div
    :id="id"
    class="group-sub-group-context"
    ref="picker"
    style="border: 1px solid red;"
  >
    <current-context :title="title" @setActiveTab=" tabName => updatePicker(tabName) "/>
    <transition v-on:enter="enter" v-on:leave="leave">
      <div class="group-sub-group-context-popup" v-if="activeTab.length > 0 && pickerActive">
        <div class="group-selection-tabs-wrapper" :class="activeTabCssClasses">
          <div class="group-selection-tabs-inner" container>
            <div class="group-selection-tabs">
              <button
                class="group-selection-tab"
                @click.stop="updatePicker('group')"
              >
                Choose A Group
              </button>
              <button
                class="group-selection-tab"
                @click.stop="updatePicker('subGroup')"
              >
                Choose A Subgroup
              </button>
            </div>
          </div>
        </div>
        <div
          class="group-sub-group-context-table-wrapper"
          v-click-outside="hide"
        >
          <div container>
            <group-context-picker v-if="activeTab === 'group'" />
            <subgroup-context-picker v-if="activeTab === 'subGroup'" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import accordionTransition from '@mixins/accordionTransition'
  import CurrentContext from './ContextPicker/CurrentContext'
  import SubgroupContextPicker from './ContextPicker/SubGroupContextPicker'
  import GroupContextPicker from './ContextPicker/GroupContextPicker'
  import { mapState, mapActions } from 'vuex'

  export default {
    mixins: [accordionTransition],
    props: {
      title: String,
      transitionName: String,
      id: {
        required: true,
        type: String
      }
    },
    components: {
      CurrentContext,
      GroupContextPicker,
      SubgroupContextPicker
    },
    methods: {
      ...mapActions('portalContext', {
        setActiveTab: 'SELECT_ACTIVE_TAB',
        setActivePicker: 'SELECT_ACTIVE_PICKER' // the picker should never open another picker in the dom.  only itself...
      }),
      hide(e) {
        if (
          document.contains(e.target) &&
          !this.$refs.picker.contains(e.target) &&
          this.pickerActive
        ) {
          this.setActivePicker('')
          this.setActiveTab('')
        }
      },
      updatePicker (tabName) {
        if (this.$refs.picker) {
          this.setActivePicker(this.$refs.picker.id).then(() => {
            this.setActiveTab(tabName)
          })
        }
      }
    },
    computed: {
      ...mapState('portalContext', ['activeTab', 'activePicker']),
      pickerActive () {
        let pickerId = (this.$refs.picker ? this.$refs.picker.id : null)
        return pickerId === this.activePicker
      },
      activeTabCssClasses() {
        switch (this.activeTab.toLowerCase()) {
        case 'group':
          return 'group-tab-active'
        case 'subgroup':
          return 'subgroup-tab-active'
        default:
          return ''
        }
      }
    },
    beforeDestroy() {
      this.setActivePicker('')
    }
  }
</script>
